import {Component, Input, OnInit} from '@angular/core';
import {EvoAbilityIconImages, EvoItemImages, EvoMonsterImages, ImageCategoryTypes} from '../../../models/questions/shared/imageType.model';

@Component({
  selector: 'app-evo-education-image',
  templateUrl: './evo-education-image.component.html',
  styleUrls: ['./evo-education-image.component.css']
})
export class EvoEducationImageComponent implements OnInit {

  @Input() category = ImageCategoryTypes.monsters;
  @Input() image: string;

  constructor() { }

  ngOnInit() {
  }

  getImgUrl(image: string) {

    if (this.category === ImageCategoryTypes.items) {
      return EvoItemImages.imgUrl(image);
    } else if (this.category === ImageCategoryTypes.monsters) {
      return EvoMonsterImages.imgUrl(image);
    } else if (this.category === ImageCategoryTypes.monsterThumbnails) {
      return EvoMonsterImages.imgUrlThumbnail(image);
    } else if (this.category === ImageCategoryTypes.abilities) {
      return EvoMonsterImages.imgUrl(image);
    }

    return null;

  }

}
